import { render } from "./EntityDetailComponent.vue?vue&type=template&id=b7b1a3d2"
import script from "./EntityDetailComponent.vue?vue&type=script&lang=js"
export * from "./EntityDetailComponent.vue?vue&type=script&lang=js"

import "./EntityDetailComponent.vue?vue&type=style&index=0&id=b7b1a3d2&lang=scss"
script.render = render

export default script